// * Migrated
import jwtDecode, { JwtPayload } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { deleteLocalStorage, getLocalStorageOrDefault } from '../utils/commonUtils';

export enum PROFILES {
  ADMINISTRADOR_DE_SISTEMA = 1,
  ADMINISTRACAO = 2,
  DIRECAO_COMERCIAL = 3,
  RESPONSAVEL_DE_AGENCIA = 4,
  CONSULTOR_COMERCIAL = 5,
  TECNICO_DE_RECRUTAMENTO = 6,
  GESTOR_DE_CLIENTE = 7,
  DIRECAO_ADMINISTRATIVA_E_FINANCEIRA = 8,
  GESTOR_DE_COBRANCA = 9,
  ADMINISTRATIVO = 10,
  ESTAGIARIO = 11,
  COORDENADOR = 12,
  DESIGNER_GRAFICO = 13,
}

export const PROFILES_ADMIN = [
  PROFILES.ADMINISTRADOR_DE_SISTEMA,
  PROFILES.ADMINISTRACAO,
  PROFILES.DIRECAO_COMERCIAL,
];
export interface JWTPayload extends JwtPayload {
  // * Custom fields
  id: number;
  profileId: number;
  agencyId: number;
  name: string;
  email: string;
  acronym: string;
}

export const useUser = (defaultUser?: JWTPayload) => {
  const [user, setUser] = useState<JWTPayload | undefined>(defaultUser);

  useEffect(() => {
    const token = getLocalStorageOrDefault('access_token');
    if (token) {
      const newUser = jwtDecode<JWTPayload>(token);
      setUser(newUser);
    } else {
      deleteLocalStorage('access_token');
      setUser(undefined);
    }
  }, []);

  const logout = () => {
    deleteLocalStorage('access_token');
    setUser(undefined);
    // tried using gatsby navigate but it stopped working so I revert that change

    // const isBrowser = () => typeof window !== "undefined"
    // if(isBrowser()){
    //   window.location.href = `${process.env.GATSBY_LEGACY_PORTAL_URL}/users/logout`;
    // }

    window.location.href = `${process.env.GATSBY_PORTAL_URL}/users/logout`;
  };

  const isAdmin = !!user && PROFILES_ADMIN.includes(user.profileId);

  return { user, isAdmin, logout };
};
